module.exports = __webpack_public_path__ + "images/feature/20190425-ff8611d63d6d9f128cab35443a3539fe.png";